import script from "./DocumentLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLine.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLine.vue?vue&type=style&index=0&id=6ca5195a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca5195a"]])

export default __exports__